import typesCommon from './types/common.types';
import { errorModel } from '../models/service/error.model';

export const addAlertFromError = error => dispatch => {
    let [title, message] = error && error.data ? [error.statusText || 'Error', error.data.message] : ['Error', error.message];

    errorModel.actionAdd(errorModel, title, message)(dispatch);
};

export const fail = (callbackErrors = {}) => dispatch => {
    return error => {
        console.warn('error', error);
        console.warn('error.stack', error.stack);

        if (error && error.response) {
            error = error.response;
        }

        if (!error) {
            dispatch({
                type: typesCommon.COMMON_HANDLE_ERROR,
                payload: { message: 'No error in try catch' }
            });
            return;
        }

        // 401
        // not call redirect to home
        // const callback = callbackErrors[typesCommon.COMMON_CALLBACK_NON_AUTH];
        // if (callback) {
        //     return callback(dispatch, error);
        // }
        // 404
        // appHistory.push(routes.login());
        // not call redirect to 404
        // const callback = callbackErrors[typesCommon.COMMON_CALLBACK_404];
        // if (callback) {
        //     return callback(dispatch, error);
        // }
        // appHistory.replace(routes.notFound());

        switch (error.status) {
            case 404:
                {
                    addAlertFromError(error)(dispatch);
                    return;
                }
            case 408:
                {
                    return;
                }
            case 401:
            case 500:
            case 400:
                {
                    addAlertFromError(error)(dispatch);
                    dispatch({
                        type: typesCommon.COMMON_HANDLE_ERROR,
                        payload: { error }
                    });
                }
            default:
                {
                    addAlertFromError(error)(dispatch);
                    dispatch({
                        type: typesCommon.COMMON_HANDLE_ERROR,
                        payload: { error }
                    });
                }
        }

        // not redirect
        // const callback = callbackErrors[typesCommon.COMMON_CALLBACK_ERROR];
        // if (callback) {
        //     return callback(dispatch, error);
        // }
    };
};

export const clearError = () => {
    return {
        type: typesCommon.COMMON_CLEAR_ERROR
    };
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/actions/common.actions.js